
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { UserService } from '../../../../shared/services/user.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { ViewPhotoComponent } from '../../../interpretation/components/view-photo/view-photo.component';
import { AppService } from '../../../../../app/app.service';
import { SetupUndercarriageService } from '../../../../modules/setup-undercarriage';
import { ManageEquipmentService } from '../../../../modules/manage-equipment/manage-equipment.service';
import { ThermographyInfoVM, ThermographyInspectionDataVM } from '../../thermography-inspection.model';
import { ThermographyInspectionService } from '../../thermography-inspection.service';
import { AddThermographyInspectionDetailsCommentComponent } from '../add-temp-inspection-details-comment/add-thermography-inspection-details-comment';
import { AttachFileDialogComponent } from '../../../../../app/modules/document-in-library/attach-file-dialog/attach-file-dialog.component';
import { AddComponentPhotoModel } from '../../../../../app/modules/interpretation/models/interpretation.model';
@Component({
  selector: 'app-insp-system',
  templateUrl: './insp-system.component.html',
  styleUrls: ['./insp-system.component.scss']
})
export class InspSystemComponent implements OnInit {
  systemTitle: string;

  @Input() side: number = -1;
  @Input() systemType: number = -1;
  @Input() FamilyImage_Chain: string="";
  @Input() FamilyImage_Frame: string="";


  @Input() FrameSystem_L:ThermographyInfoVM[] =null;
  @Input() ChainSystem_L:ThermographyInfoVM[]=null;

  @Input() FrameSystem_R:ThermographyInfoVM[] =null;
  @Input() ChainSystem_R:ThermographyInfoVM[]=null;

  @Input() AdditionalSys_L:ThermographyInfoVM[] =null;
  @Input() AdditionalSys_R:ThermographyInfoVM[] =null;
  @Input() AdditionalSys_N:ThermographyInfoVM[] =null;



  // @Input() FrameSystem_R:ThermographyInfoVM[]=null;
  // @Input() ChainSystem_R:ThermographyInfoVM[]=null;

  

  @Input() SerialNo:string;
  @Input() tracksag_L:number;
  @Input() tracksag_R:number;

  @Input() chain_CMU:number;


  loadingSystems = true;
  EquipmentDetails;
  equipmentId:number;
  inspectionId:number;
  constructor(
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _cdr: ChangeDetectorRef,
    private _user: UserService,
    private _loading: LoadingService,
    private route: ActivatedRoute,
    private _appSerivce: AppService,
    private _setupService: SetupUndercarriageService,
    private _equipmentService: ManageEquipmentService,
    private _app: AppService,
    private _thermographyService:ThermographyInspectionService
  ) { }

  ngOnInit() {
    
    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.inspectionId = +this.route.snapshot.paramMap.get('id2');
    this.assignTitle();
  }

  

  AddComment(InspectionDetailId:number, comment:string,isedit:boolean,side:number,system:number){
    const newInspectionDetailCommentDialog = this._dialog.open(AddThermographyInspectionDetailsCommentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
          equipmentId: this.equipmentId,
          inspectionDetailID:InspectionDetailId,
          Inspcomment: comment,
          isedit:isedit,
          isWsre:false,
      },
      minWidth: 500
  });
  
  newInspectionDetailCommentDialog.afterClosed().subscribe(result => {
  
      if (result) {
        this.LoadInspectionDetails(side,system);
          //this.loadTemperatureInspection();
          //this.LoadMoreInspections();
      }
  });
  }

  InspectionDetails:ThermographyInspectionDataVM;
  SpecificInspectionDetails:ThermographyInfoVM[]=[];


  
  
  LoadInspectionDetails(side:number,system:number){
    this._thermographyService.GetSpecificThermogarphyInspectionInfo(side,system, this.inspectionId,this.equipmentId).subscribe(res=>{
      this.SpecificInspectionDetails = res;
      console.log("specific___", this.SpecificInspectionDetails)
if(system==1){
  if(side==1)
  this.ChainSystem_L = this.SpecificInspectionDetails;
  else
  this.ChainSystem_R=this.SpecificInspectionDetails;
}
if(system==2){
  if(side==1)
  this.FrameSystem_L = this.SpecificInspectionDetails;
  else
  this.FrameSystem_R=this.SpecificInspectionDetails;
  
}
if(system==0){
  if(side==1)
  this.AdditionalSys_L = this.SpecificInspectionDetails;
  else if(side==2)
  this.AdditionalSys_R=this.SpecificInspectionDetails;
  else
  this.AdditionalSys_N=this.SpecificInspectionDetails;
}


     
  
     
  
      // this.SerialC_l=this.InspectionDetails.Chains.ChainLSerial;
      // this.SerialC_r=this.InspectionDetails.Chains.ChainRSerial;
      // this.SerialF_l=this.InspectionDetails.Frames.FrameLSerial;
      // this.SerialF_r=this.InspectionDetails.Frames.FrameRSerial;
      // this.smu = this.InspectionDetails.SMU;
      // this.InspectionDate = this.InspectionDetails.InspectionDate;
      // this.comment=this.InspectionDetails.Comment;
      // this.tracksag_l=this.InspectionDetails.trackSagL;
      // this.tracksag_r=this.InspectionDetails.trackSagR;
      // this.chain_CMU_l=this.InspectionDetails.Chains.CMU_Left;
      // this.chain_CMU_r=this.InspectionDetails.Chains.CMU_Right;
  
  
       console.log("InsopectionDetails__", this.InspectionDetails);
        // this.Loadall=true;
        // this._loading.finishedLoading();
      
    });
  }
  trackValue:number;
  UpdateTrackSag(side:number){
    console.log("VALUE", this.tracksag_L,this.tracksag_R)
    this.trackValue= side==1?this.tracksag_L:this.tracksag_R;
    this._thermographyService.UpdateTrackSag(this.inspectionId,this.trackValue,side).subscribe(r=>{
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        
      } else {
        this._notify.error('Failed', r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to save Evaluation. Please contact TrackTreads support. ', err);
    });
  }

viewInspectionDetailPhoto(thermoInspectionDetailId: number,thermoInspectionDetailPhoto:string,isedit:boolean,side:number,system:number)
{
  const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    data: {
      thermoInspectionDetailId : thermoInspectionDetailId,
      thermoInspectionDetailPhoto:thermoInspectionDetailPhoto,
      isedit:isedit
    }
  });
  viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
    if (reloadPhoto){
      this.LoadInspectionDetails(side,system);
    }

    
    //this.loadTemperatureInspection();
    //this.LoadMoreInspections();
  });
}
  changeEval(InspectionDetailId:number, event:any){

    console.log("Eval", InspectionDetailId,event)
    this._thermographyService.UpdateThermographyEval(InspectionDetailId,event.value).subscribe(r=>{
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        
      } else {
        this._notify.error('Failed', r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to save Evaluation. Please contact TrackTreads support. ', err);
    });
  }

  getImage_(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }
  getEquipmentDetails() {
    this._equipmentService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
      this.EquipmentDetails = equipment;
    });
    if (this.EquipmentDetails !== null) {}
   
  }


  assignTitle() {

    if (this.systemType === 1) {
      this.side === 1 ? this.systemTitle = 'Left Side Chain' : this.systemTitle = 'Right Side Chain';
    }    else if(this.systemType === 2) {
      this.side === 1 ? this.systemTitle = 'Left Side Frame' : this.systemTitle = 'Right Side Frame';
    }
    else
    if(this.side === 1)
    this.systemTitle = 'Left Side Additional Component';
    else if(this.side==2)
    this.systemTitle = 'Right Side Additional Component';
    else
    this.systemTitle = 'No Side Additional Component'

    
  }

  showPosition(position: number, compartTypeId: number): string {
    
        return this._app.getPositionString(position, compartTypeId);
    }
   
    openAttachDoc(c:ThermographyInfoVM,side:number,system:number)
    {
      const dialogRef = this._dialog.open(AttachFileDialogComponent, {
        data: { 
          NewFileName:"",
          FilePreview:null
        }
      });
      dialogRef.afterClosed().subscribe(res => {
        console.log("res",res)
        if (res !=false && res.FilePreview!="") {
          c.FilePreview=res.FilePreview; 
          c.NewFileName=res.NewFileName;

          const doc = new AddComponentPhotoModel();
          doc.InspectionId = this.inspectionId;
          doc.InspectionDetailId = c.DetailId;
          doc.NewPhoto = res.FilePreview;
          this._thermographyService.updateThermographyDocument(doc).subscribe(r => {
            if (r.m_Item1) {
              this._notify.success('Saved', r.m_Item2);
              this.LoadInspectionDetails(side,system);
            } else {
              this._notify.error('Failed', r.m_Item2, r.m_Item2);
            }
          }, err => {
            this._notify.error('Failed', 'Unable to save document. Please contact TrackTreads support. ', err);
          });

          
        }
     
      });
      
    }

    onClickDownloadForm(c:ThermographyInfoVM) {

      var newstring = c.FilePreview.slice(1);
  
      let _newstring = newstring.substring(0, newstring.length - 1);
  
      var arrBuffer = this.base64ToArrayBuffer(c.FilePreview);
  
  
        var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
        var link = document.createElement('a');    
        link.href = window.URL.createObjectURL(blob);
        link.download = c.ComponentName + '.pdf';
        link.click();
    
      // else if(c.Extension =='xls'){
      //   var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
      //   var link = document.createElement('a');    
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = c.NewFileName + '.xls';
      //   link.click();
      // }
      // else if(c.Extension =='docx'){
      //   var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });  
      //   var link = document.createElement('a');    
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = c.NewFileName + '.docx';
      //   link.click();
      // }
      // else if(c.Extension =='png'){
      //   var blob = new Blob([arrBuffer], { type: 'image/png' });  
      //   var link = document.createElement('a');    
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = c.NewFileName + '.png';
      //   link.click();
      // }
  
      // else if(c.Extension =='jpg'){
      //   var blob = new Blob([arrBuffer], { type: 'image/jpg' });  
      //   var link = document.createElement('a');    
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = c.NewFileName + '.jpg';
      //   link.click();
      // }
  
      // else if(c.Extension =='txt'){
      //   var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });  
      //   var link = document.createElement('a');    
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = c.NewFileName + '.txt';
      //   link.click();
      // }
  }
  
  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

}
